import { baseApi } from "configs/store-query";

const BASE_URL = `v1/account`;

const accountApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    loginAccount: builder.mutation({
      query: (config) => ({
        url: `${BASE_URL}/login`,
        method: "post",
        ...config,
      }),
    }),
  }),
});

export default accountApi;
